/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Navigation')
    .directive('accNavigationMenu', ['template', '$location', '$routeParams', 'ENV',
        function(template, $location, $routeParams, ENV) {
            return {
                replace: true,
                templateUrl: template('_navigation_menu'),
                link: function($scope) {
                    $scope.cloudPlatformNotaryVerifyAddress = ENV['cloudPlatformNotaryPath'] + '/verify';

                    $scope.quotaInfo = {
                        shown: false,
                        show: function() {
                            this.shown = true;
                        },
                        hide: function() {
                            this.shown = false;
                        }
                    };

                    $scope.isActive = function(viewLocation) {
                       return $location.path().indexOf(viewLocation) !== -1;
                    };
                }
            };
        }
    ]);
